import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

class LinksCardsSlider {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.swiperEl = this.root.querySelector(
            '[data-links-cards-slider-swiper]'
        );
        this.prevEl = this.root.querySelector(
            '[data-links-cards-slider-swiper-prev]'
        );
        this.nextEl = this.root.querySelector(
            '[data-links-cards-slider-swiper-next]'
        );
        this.paginationEl = this.root.querySelector('[swiper-pagination]');

        return true;
    }

    init() {
        this.setSwiper();
    }

    setSwiper() {
        if (!this.swiperEl) return;

        this.swiper = new Swiper(this.swiperEl, {
            modules: [Navigation, Pagination],
            speed: 650,
            slidesPerView: 1.15,
            spaceBetween: 16,
            breakpoints: {
                768: {
                    slidesPerView: 1.5,
                },
                1280: {
                    slidesPerView: 2,
                },
            },
            navigation: {
                prevEl: this.prevEl,
                nextEl: this.nextEl,
            },
            pagination: {
                el: this.paginationEl,
                type: 'progressbar',
            },
        });
    }
}

const sections = document.querySelectorAll('[data-links-cards-slider]');
const setLinksCardsSlider = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new LinksCardsSlider(el);
    });
};

setLinksCardsSlider(sections);
